import { CIcon } from '~/icons/types'

export const ciRotate: CIcon = {
  width: 15,
  height: 16,
  paths: [
    {
      d:
        'M0 5.09A8.013 8.013 0 0 1 7.5 0c3.09 0 5.81 1.746 7.135 4.295l-1.198.61c-1.1-2.118-3.366-3.572-5.937-3.572a6.666 6.666 0 0 0-6.245 4.243L0 5.09Zm15 5.82A8.013 8.013 0 0 1 7.5 16a8.135 8.135 0 0 1-7.202-4.36l1.198-.61A6.786 6.786 0 0 0 7.5 14.667a6.666 6.666 0 0 0 6.245-4.242l1.255.484Z'
    },
    {
      d:
        'M13.564 4V.667h1.348v4.667h-4.717V4h3.37ZM.089 10.665h4.716v1.333H1.436v3.334H.09v-4.667Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'rotate',
  type: 'regular'
}
